module.exports = __webpack_public_path__ + "img/horizontal_4_3_8023.284a1293.png";